import { apiClient } from './client';

/** Espejo de CalculatorInputSpec (aws-serverless/src/services/calculators/catalog.ts). */
export interface CalculatorInputSpec {
  clave: string;
  etiqueta: string;
  unidad?: string;
  obligatoria: boolean;
  fuente?: 'sistema' | 'usuario';
}

export interface CalculatorInfo {
  id: string;
  titulo: string;
  entradas: CalculatorInputSpec[];
}

/** GET /calculators: catálogo sin funciones. */
export async function fetchCalculators(): Promise<CalculatorInfo[]> {
  const res = await apiClient.get('/api/calculators');
  return res.data;
}

/** POST /calculators/:id: corre la calculadora con los supuestos del usuario. */
export async function runCalculator(id: string, input: Record<string, unknown>): Promise<Record<string, unknown>> {
  const res = await apiClient.post(`/api/calculators/${id}`, input);
  return res.data;
}
